









import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import MessageStore from '../../store/modules/messages'
import { rdb } from '../../firebase/init'
import { MessageType } from '../../types'
import SingleMessage from './SingleMessage.vue'

@Component({
  components: {
    SingleMessage,
  },
})
export default class MessageWrapper extends Mixins(MainMixin) {
  @Prop() messageType!:string

  Message = getModule(MessageStore)

  newMessage = ''

  loading = false

  async sendMessage() {
    console.log('sending Message!')
    this.loading = true
    let ref:any
    if (this.messageType === 'manager') {
      ref = rdb.ref(`/locations/${this.location}/messages/${this.uid}`)
    }
    if (this.messageType === 'annoucement') {
      ref = rdb.ref(`locations/${this.location}/messages/announcements`)
    }
    if (this.messageType === 'group') {
      ref = rdb.ref(`locations/${this.location}/messages/group`)
    }
    if (ref) {
      console.log('here')
      try {
        const result = await ref.push({ created: new Date().toISOString(), user: this.uid, message: this.newMessage })
        console.log('result is: ', result)
      } catch (e) {
        console.log('error: ', e)
      }
      this.newMessage = ''
    }
    this.loading = false
  }

  get allMessages() {
    // @es-ignore
    if (this.messageType === 'manager') return this.Message.managerMessages
    if (this.messageType === 'annoucement') return this.Message.announcements
    if (this.messageType === 'group') return this.Message.groupMessages
    return []
  }
}

